@if (asset$ | async; as asset) {
    <div class="flex column root align-stretch justify-stretch">
        <div class="header-link">
            <a href="/v/{{ asset.id }}" target="_blank">
                <h2 class="flex row align-start justify-center">
                    <img src="{{ asset.author.email | identicon | async }}" class="user-icon" />
                    {{ asset.name }}
                </h2>
            </a>
        </div>
        <frog-video [asset]="asset" [embedded]="true"></frog-video>
    </div>
} @else {
    @if (loading) {
        <frog-async-spinner></frog-async-spinner>
    } @else {
        <div class="flex column align-center justify-stretch not-found">
            <h1>
                <mat-icon>error_outline</mat-icon>
                Video Not Found
            </h1>
        </div>
    }
}
